module.exports = __webpack_public_path__ + "static/img/curstage_2.28ac30c0.png";